module.exports = __webpack_public_path__ + "img/banner_20240125174140.235c2d87.jpg";